<template>
  <el-dialog title="批量操作" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form size="small" :model="formData" :rules="formRules" ref="form">

      <!--是否显示-->
      <el-form-item label="是否热门推荐" prop="is_hot" :label-width="formLabelWidth">
        <el-radio-group v-model="formData.is_hot">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="报考专业" prop="exam_type" :label-width="formLabelWidth">
        <!-- <el-radio-group v-model="formData.exam_type">
          <p><el-radio :label="0">不分类</el-radio></p>
          <p class="mt10"><el-radio :label="1">应用心理专硕</el-radio></p>
          <p class="mt10"><el-radio :label="2">心理学学硕（312统考）</el-radio></p>
          <p class="mt10"><el-radio :label="3">心理学学硕（院校自主命题）</el-radio></p>
          <p class="mt10"><el-radio :label="4">心理健康教育专硕</el-radio></p>
        </el-radio-group> -->
        <el-select v-model="formData.exam_type" multiple clearable placeholder="请选择" style="width:200px">
          <el-option :label="v.label" :value="v.value" v-for="(v, i) in exam_type" :key="i"></el-option>
        </el-select>

        <!-- <el-checkbox-group v-model="formData.exam_type">
          <el-checkbox v-for="(v, i) in exam_type" :label="v.value" :key="i">{{v.label}}</el-checkbox>
        </el-checkbox-group> -->
      </el-form-item>

      <!--是否显示-->
      <el-form-item label="状态" prop="status" :label-width="formLabelWidth">
        <el-radio-group v-model="formData.status">
          <el-radio :label="1">显示</el-radio>
          <el-radio :label="0">隐藏</el-radio>
        </el-radio-group>
      </el-form-item>

      <!--是否删除-->
      <el-form-item label="删除" prop="is_delete" :label-width="formLabelWidth">
        <el-radio-group v-model="formData.is_delete">
          <el-radio label="">否</el-radio>
          <el-radio :label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>
      
    </el-form>
    <!--操作按钮-->
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="onSubmit()" :disabled="loading || ids.length==0">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import SchoolApi from '@/api/study/school.js';
import { alphabet } from '@/utils/base.js';
export default {
  data() {
    return {
      /*是否加载中*/
      loading: false,
      /*form表单数据对象*/
      formData: {
        ids: [],
        is_hot: '',
        exam_type: '',
        status: '',
        is_delete: '',
      },
      /*验证规则*/
      formRules: {},
      /*左边长度*/
      formLabelWidth: '120px',
      /*是否显示*/
      dialogVisible: false,
    };
  },
  props: ['is_open', 'ids', 'exam_type'],
  created() {
    this.dialogVisible = this.is_open;
    this.formData.ids = this.ids;
  },
  methods: {
    /*添加*/
    onSubmit() {
      let self = this;
      let params = this.formData;
      if (params.ids.length<=0){
        self.$message({
          message: '暂无选中记录',
          type: 'warning'
        });
        return;
      }
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          SchoolApi.batch(params, true)
            .then(res => {
              if (res.code == 1) {
                self.$message({
                  message: res.msg,
                  type: 'success'
                });
                self.dialogFormVisible(true);
                self.loading = false;
              }
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit('closeDialog', {
          type: 'success',
          openDialog: false
        });
      } else {
        this.$emit('closeDialog', {
          type: 'error',
          openDialog: false
        });
      }
    },
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/study/school/part/Batch.vue